import { SIDE_NAV_WIDTH_COLLAPSED_PX, SIDE_NAV_WIDTH_PX } from "globalStylesVariables";
import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  option: {
    "&:hover:not($active)": {
      backgroundColor: "color-mix(in srgb, transparent, var(--sidebar-foreground) 10%)",
    },
    "justifyContent": "space-between",
    "alignItems": "center",
    "padding": "0 24px",
    "transition": "background-color 0.2s",
    "display": "flex",
    "textDecoration": "none",
    "height": 40,
    "width": `${SIDE_NAV_WIDTH_PX}px`,
  },
  active: {
    backgroundColor: "var(--sidebar-primary)",
    cursor: "default",
  },
  text: {
    "opacity": 1,
    "transition": "0.6s opacity ease",
    "&$minimized": { opacity: 0 },
    "display": "inline-flex",
    "justifyContent": "center",
  },
  title: {
    justifyItems: "flex-start",
    alignItems: "center",
    display: "flex",
    gap: 12,
    color: "var(--sidebar-foreground)",
  },
  minimized: {},
  chip: {
    fontSize: 10,
  },
  container: {
    "maxWidth": `${SIDE_NAV_WIDTH_PX}px`,
    "&$minimized": { maxWidth: `${SIDE_NAV_WIDTH_COLLAPSED_PX}px` },
    "overflow": "visible",
  },
  tooltip: {
    backgroundColor: "var(--sidebar)",
    color: "var(--sidebar-foreground)",
  },
});
